import React, { useEffect, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import {
  Table,
  Button,
  Modal,
  Form,
  Container,
  Row,
  Col,
  Select,
} from "react-bootstrap";
import { InputField } from "../../components/InputField/InputField";
import { useForm, SubmitHandler } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import validation from "./validation";
import services from "../../API/services";
import { useDispatch, useSelector } from "react-redux";
import {
  getRroomPropertyAction,
  propertySeletor,
} from "../../store/slices/propertySlice";
import Moment from "react-moment";
import ImageUploadBox from "../../components/imageUploadBox";
import { City, Country, State } from "country-state-city";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { baseImgUrl } from "../../API/client/api";

const Amenities = () => {
  const { InternetIcon, AlertIcon } = Imagesdata || {};
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [amenitiesData, setAmenitiesData] = useState([]);
  const [imageData, setImageData] = useState([]);
  const [showImageOnEdit, setShowImageOnEdit] = useState('')
  const imageHandler = (data) => {
    setImageData((preValue) => {
      return [...preValue, data];
    });
  };

  // const {
  //   register,
  //   handleSubmit,
  //   setError,
  //   reset,
  //   setValue,
  //   control,
  //   formState: { errors, isValid, isSubmitted },
  // } = useForm({ ...validation, mode: "onSubmit" });

  const {
    register,
    handleSubmit,
    setError,
    reset,
    setValue,
    control,
    formState: { errors, isValid, isSubmitted },
  } = useForm();

  useEffect(() => {
    getAmenities();
  }, []);

  const getAmenities = async () => {
    try {
      const res = await services.property.getAmenitiesService();
      if (res.status === 200) {
        setAmenitiesData(res?.data?.data);
      }
    } catch (error) { }
  };

  const onSubmit = async (payload) => {
    var bodyFormData = new FormData();
    if(!editMode){
      if (!imageData?.length) {
        toast.error("Please Select Image*", {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
        return;
      }
    }

    bodyFormData.append("icon", imageData[0]);
    bodyFormData.append("name", payload.name);
    bodyFormData.append("type", payload.type);
    bodyFormData.append("status", 0);

    try {
      if (editMode) {
        let realPayload = {
          id: payload.id,
          body: bodyFormData,
        };
        const res = await services.property.editAmenitiesService(realPayload);
        if (res.status === 200) {
          setEditMode(false);
          reset();
          getAmenities();
          setShow(false);
          toast.success("Room Amenities Updated SuccessFull !", {
            autoClose: 1000,
            pauseOnHover: true,
            position: "top-right",
          });
        }
      } else {
        const res = await services.property.createAmenitiesService(
          bodyFormData
        );
        if (res.status === 200) {
          reset();
          getAmenities();
          setShow(false);
          setImageData([])
          toast.success("Room Amenities Created SuccessFull !", {
            autoClose: 1000,
            pauseOnHover: true,
            position: "top-right",
          });
        }
      }
    } catch (error) { }
  };

  const editHandler = (data) => {
    setValue("name", data.name);
    setValue("icon", data.icon);
    setValue("id", data.id);
    setValue("type", data.type);
    setEditMode(true);
    setShow(true);

    setShowImageOnEdit(data.icon)
  };

  const deleteHandler = async () => {
    try {
      const res = await services.property.deleteAmenitiesService(
        selectedData.id
      );
      if (res.status === 200) {
        getAmenities();
        setShowDelete(false);
        toast.success("Room Amenities Deleted SuccessFull !", {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
      }
    } catch (error) { }
  };

  return (
    <Layout title="Room Amenities" openHandler={() => setShow(true)}>
      <div className="onboardDetails">
        <div className="wrap">
          <div className="inner">
            <div className="table-box">
              <table>
                <thead>
                  <tr>
                    <th>Serial Number</th>
                    <th>Amenitie Name</th>
                    <th>Amenitie Type</th>
                    <th>Amenitie Icon</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {amenitiesData.map((data, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{data.name}</td>
                      <td>{data.type}</td>
                      <td>
                        <img
                          src={`${baseImgUrl}${data.icon}`}
                          style={{ width: "30px", marginLeft: "20px" }}
                          alt="icons"
                        />
                      </td>
                      <td>
                        <div className="button-group">
                          <Button
                            variant="primary"
                            onClick={() => editHandler(data)}
                          >
                            <i className="fa fa-pencil" aria-hidden="true"></i>
                          </Button>
                          <Button
                            variant="primary"
                            onClick={() => {
                              setShowDelete(true);
                              setSelectedData(data);
                            }}
                          >
                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
          setEditMode(false);
          setShowImageOnEdit('')
          reset();
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Modal.Title>
              {editMode ? "Edit" : "Create Amenitie"}
            </Modal.Title>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            className="popup-form onboardForm"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Container>
              <Row>
                <Col xs={6} className="form-group">
                  <label className="label form-label">Amenitie Name *</label>
                  <input type="text"
                    className="form-control"
                    {...register("name", { required: "Name is required" })}
                    placeholder="Enter Amenitie Name"
                  />
                  {errors?.name?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"name"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={6} className="form-group">
                  <label className="label form-label">Select Amenities Type *</label>
                  <select {...register("type", { required: "Type is required" })}>
                    <option value="">Select Type</option>
                    <option value="hotel">Hotel</option>
                    <option value="room">Room</option>
                  </select>
                  {errors?.type?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>
                        <ErrorMessage errors={errors} name={"type"} />
                      </span>
                    </div>
                  )}
                </Col>
                <Col xs={12}>
                  <label>Upload amenities icons</label>
                  <ImageUploadBox imageHandler={imageHandler} />
                  {imageData.length == 0 && showImageOnEdit && <img style={{width: '70px', marginTop: '-25px', marginBottom: '20px'}} src={`${baseImgUrl}${showImageOnEdit}`} />}
                </Col>
                <Col xs={12} className="form-group">
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDelete}
        onHide={() => {
          setShowDelete(false);
        }}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <div className="deleteModal">
              <span>Are you sure? Do you want to delete this record?</span>
              <span>You will not be able to recover this record!</span>
            </div>
            <Button
              variant="primary"
              className="btn-sm"
              type="button"
              onClick={deleteHandler}
            >
              Yes , Delete
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export default Amenities;
